
import LazyCatalogContent from '~/components/header/mobile/LazyCatalogContent';

export default {
  name: 'Catalog',
  data() {
    return {
      menu: [],

      isShowDropDown: false,
    };
  },
  components: { LazyCatalogContent },
  props: {
    catalog: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  computed: {
    buttonIcon() {
      if (this.isShowDropDown && this.catalog.length) {
        return require('~/assets/img/svg/header/close.svg');
      }

      return require('~/assets/img/svg/header/menu.svg');
    },
  },
  methods: {
    setName(item) {
      return item?.name || item.title;
    },
    clickButton() {
      this.isShowDropDown = !this.isShowDropDown;
    },
  },
};
